'use client'

import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'
import { ConditionalBadge, FieldError, FieldHelpText } from './field-shell'
import type { AnswerableFieldProps } from './types'

/**
 * Single consent-style checkbox. The label sits inline beside the box, so
 * this field composes its own layout rather than using `FieldShell`'s
 * top-label wrapper — but it reuses the shared help/error rows and the same
 * preview-mode `pointer-events-none` selection passthrough.
 */
export function CheckboxField({ props, mode, value, onChange, error }: AnswerableFieldProps<'Checkbox', boolean>) {
  const isPreview = mode === 'preview'
  return (
    <div className={cn('flex items-start gap-2', isPreview && 'pointer-events-none select-none')}>
      <Checkbox
        id={props.id}
        checked={isPreview ? false : value === true}
        onCheckedChange={isPreview ? undefined : checked => onChange?.(checked === true)}
      />
      <div className="space-y-1">
        <div className="flex items-center gap-2">
          <Label htmlFor={props.id}>{props.label}</Label>
          {isPreview && props.showIf && <ConditionalBadge />}
        </div>
        <FieldHelpText helpText={props.helpText} />
        <FieldError error={error} />
      </div>
    </div>
  )
}
